/* MODALE CANCELLA PRENOTAZIONE */

import { useIntl, defineMessages } from 'react-intl';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  notify,
} from 'design-react-kit';
import { deleteBooking } from '@redturtle/volto-io-prenoto/actions/booking';
import { FormattedDate } from '@redturtle/volto-io-prenoto/components/View/Commons';

const messages = defineMessages({
  modal_button_cancel: {
    id: 'booking_modal_button_cancel',
    defaultMessage: 'Annulla',
  },
  modal_button_confirm: {
    id: 'booking_modal_button_confirm',
    defaultMessage: 'Conferma',
  },
  modal_title_delete: {
    id: 'booking_modal_title_delete',
    defaultMessage: 'Cancella prenotazione',
  },
  modal_body_delete: {
    id: 'booking_modal_body_delete',
    defaultMessage: 'Sei sicuro di voler cancellare la prenotazione del giorno',
  },
  modal_body_delete_hours: {
    id: 'booking_modal_body_delete_hours',
    defaultMessage: 'alle ore',
  },
  message_delete_confirmed: {
    id: 'booking_message_delete_confirmed',
    defaultMessage: 'Cancellazione confermata',
  },
  message_delete_error: {
    id: 'booking_message_delete_error',
    defaultMessage: 'Errore durante la cancellazione.',
  },
  no_notifications_will_sent: {
    id: 'booking_delete_no_notifications_will_sent',
    defaultMessage:
      "Attenzione: questa operazione non verrà notificata all'utente via email.",
  },
});

const PrenotazioneDeleteModal = ({
  isOpen,
  toggleModal,
  booking,
  setLoadDelete,
  functionAfterDelete,
  fromBackoffice,
  notificationsEmail,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const deleteBookingResponse = useSelector(
    (state) => state.deleteBookingResponse,
  );

  const toastNotificationDelete = (message, state) => {
    notify(message, {
      state: state,
      fix: 'bottom',
    });
  };

  useEffect(() => {
    if (deleteBookingResponse?.loaded) {
      // disabled button booking delete
      if (setLoadDelete) {
        setLoadDelete(true);
      }
      // notify success delete
      toastNotificationDelete(
        intl.formatMessage(messages.message_delete_confirmed),
        'success',
      );

      // function triggered after delete
      if (functionAfterDelete) {
        functionAfterDelete();
      }
    }
    if (deleteBookingResponse?.error) {
      // notify error delete
      toastNotificationDelete(
        deleteBookingResponse.error?.response?.body?.message ||
          intl.formatMessage(messages.message_delete_error),
        'error',
      );
      if (setLoadDelete) {
        setLoadDelete(false);
      }
    }
  }, [deleteBookingResponse]);

  const deleteBookingButton = () => {
    dispatch(deleteBooking(booking.UID ?? booking.booking_id));
    // close modal
    toggleModal(!isOpen);
  };

  return (
    <Modal
      id="modal-delete-prenotazione"
      isOpen={isOpen}
      centered
      toggle={() => toggleModal(!isOpen)}
    >
      <ModalHeader
        icon="it-delete"
        toggle={() => toggleModal(!isOpen)}
        tag="div"
      >
        <h3 className="mx-2 mb-0">
          {intl.formatMessage(messages.modal_title_delete)}
        </h3>
      </ModalHeader>
      <ModalBody className="mb-4 mb-lg-4">
        {booking && (
          <>
            <p>
              {intl.formatMessage(messages.modal_body_delete)}{' '}
              <span className="text-capitalize">
                <strong>
                  <FormattedDate
                    date={booking.booking_date}
                    format="date_human"
                  />
                </strong>{' '}
              </span>
              {intl.formatMessage(messages.modal_body_delete_hours)}{' '}
              <strong>
                <FormattedDate date={booking.booking_date} format="time" />
              </strong>
              ?
            </p>
            {fromBackoffice && !notificationsEmail && (
              <p className="mt-4">
                {intl.formatMessage(messages.no_notifications_will_sent)}
              </p>
            )}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={() => deleteBookingButton()}>
          {intl.formatMessage(messages.modal_button_confirm)}
        </Button>
        <Button outline color="primary" onClick={() => toggleModal(!isOpen)}>
          {intl.formatMessage(messages.modal_button_cancel)}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PrenotazioneDeleteModal;
